import { connect, featureOn, screenreaderNotification, addError, removeAlert, quizBuildingSession, clearErrorsShowing, clearActiveQuizSession, getActiveQuiz, modalActions } from '@instructure/quiz-core';
import { Build as BuildPresenter } from './presenter';
function mapStateToProps(state) {
  var activeQuiz = getActiveQuiz(state);
  var quizEntriesIncludingTemp = activeQuiz.getWorkingQuizEntries();
  var isEditing = state.get('editing') && state.get('editing').some(function (elem) {
    return elem;
  });
  return {
    banks: state.get('banks'),
    // needed to force Build to re-render when banks are deleted
    isEditing: isEditing,
    quiz: activeQuiz,
    quizEntries: quizEntriesIncludingTemp,
    useBankTags: featureOn('item_bank_tagging')
  };
}
var mapDispatchToProps = {
  addError: addError,
  clearErrorsShowing: clearErrorsShowing,
  clearActiveQuizSession: clearActiveQuizSession,
  modalActions: modalActions,
  quizBuildingSession: quizBuildingSession,
  removeAlert: removeAlert,
  screenreaderNotification: screenreaderNotification
};
export var Build = connect(mapStateToProps, mapDispatchToProps)(BuildPresenter);
export default Build;